import { parse } from 'query-string';
import { getLang } from '../Utils/locale';
import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';
import { vouchersReducerActionTypes } from './vouchers-reducer';

const initialDuration = Number(parse(window.location.search).duration);
const lang = getLang(parse(window.location.search).lang);
const shopId = parse(window.location.search).shopId;

export enum giftcardReducerActionTypes {
  UPDATE_GIFTCARD = 'GIFTCARD_UPDATE_GIFTCARD',
  UPDATE_DURATION = 'GIFTCARD_UPDATE_DURATION',
}

interface GiftcardUpdateGiftcardAction {
  type: giftcardReducerActionTypes.UPDATE_GIFTCARD;
  payload: Partial<GiftcardReducerState>;
}

interface GiftcardUpdateDurationAction {
  type: giftcardReducerActionTypes.UPDATE_DURATION;
  payload: number | string;
}

interface VouchersUpdateVouchersAction {
  type: vouchersReducerActionTypes.UPDATE_VOUCHERS;
  payload: {
    changes?: {
      giftcard?: {
        duration?: number;
        type?: string;
        campaignName?: string;
      };
    };
  }[];
}

interface SelecetedShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

// combine all the action types into one type
export type GiftcardReducerAction =
  | GiftcardUpdateGiftcardAction
  | GiftcardUpdateDurationAction
  | VouchersUpdateVouchersAction
  | SelecetedShopIdAction;

export interface GiftcardReducerState {
  shopId: string | null;
  duration: number;
  lang: string;
  type: string;
  campaignName: string | null;
}

export const giftcardReducerInitialState: GiftcardReducerState = {
  shopId: typeof shopId === 'string' ? shopId : null,
  duration: initialDuration || 2,
  lang: lang || 'en',
  type: 'default',
  campaignName: null,
};

const giftcardReducer = (
  state: GiftcardReducerState,
  action: GiftcardReducerAction
): GiftcardReducerState => {
  switch (action.type) {
    case giftcardReducerActionTypes.UPDATE_GIFTCARD: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case giftcardReducerActionTypes.UPDATE_DURATION: {
      return {
        ...state,
        duration: Number(action.payload),
      };
    }
    case vouchersReducerActionTypes.UPDATE_VOUCHERS: {
      return {
        ...state,
        duration: action.payload[0]?.changes?.giftcard?.duration ?? state.duration,
        type: action.payload[0]?.changes?.giftcard?.type ?? state.type,
        campaignName:
          action.payload[0]?.changes?.giftcard?.campaignName ?? state.campaignName,
      };
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return {
        ...giftcardReducerInitialState,
        shopId: action.payload,
        lang: state.lang,
      };
    }
    default: {
      return state;
    }
  }
};

export default giftcardReducer;
